
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reference/actions/add-row",
      function () {
        return require("private-next-pages/reference/actions/add-row.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reference/actions/add-row"])
      });
    }
  